// Errors thrown inside a user's browser extension are not application errors,
// but the browser reports them on our page and RUM ingests them as ours. One
// misbehaving extension at a single tenant produced 108,898 errors in a week --
// the largest signature in admin-web, and entirely third-party. Left in, it
// distorts every error count we read and can hide a real regression underneath.
const EXTENSION_SCHEMES = [
  "chrome-extension://",
  "moz-extension://",
  "safari-extension://",
  "safari-web-extension://",
  "ms-browser-extension://",
  // Safari rewrites injected-script URLs to this rather than naming the scheme.
  "webkit-masked-url://"
];

// Stack formats differ by engine: V8 prefixes a message line and uses `at `,
// Safari and Firefox emit bare `fn@url` lines. Detect frames rather than
// slicing by position, which drops a real frame on non-V8. Same approach as
// originStack in lib/datadog.js.
function stackFrames(stack) {
  return stack
    .split("\n")
    .map((line) => line.trim())
    .filter((line) => line.startsWith("at ") || line.includes("@"));
}

// True only when EVERY frame is extension code.
//
// Deliberately not "any frame is an extension": an extension can invoke our
// code, and then ours is the frame that actually threw and we want to hear
// about it. Requiring all frames means a mixed stack is always kept, so this
// can only ever discard errors we had no part in.
//
// A message line containing "@" (an email, say) is picked up as a frame by the
// detector above and will not match a scheme, so the event is kept. That fails
// in the safe direction.
export function isBrowserExtensionError(event) {
  if (event?.type !== "error") return false;

  const stack = event?.error?.stack;
  if (typeof stack !== "string") return false;

  const frames = stackFrames(stack);
  if (!frames.length) return false;

  return frames.every((frame) =>
    EXTENSION_SCHEMES.some((scheme) => frame.includes(scheme))
  );
}
